const bsCollapse = require("Scripts/common/bs-collapse");

/**
 * Dynamically creates and displays a dismissible global error alert at the top of the page.
 * 
 * This injects a new alert element directly into the document body, making it ideal for 
 * global error handling (e.g., failed `fetchJson` requests) where a pre-existing 
 * error container isn't available in the DOM. It automatically hides and replaces 
 * any previously displayed error bars.
 * 
 * @param {Error} [error] - Optional error object
 */
export default function showErrorBar(error) {
	console.log("showErrorBar", error);

	// Hide previously shown errors
	bsCollapse($(".sticky-error")).hide();

	const errorDiv = document.createElement("div");
	errorDiv.className = "alert alert-red alert-dismissible sticky-error collapse";

	const closeButton = document.createElement("button");
	closeButton.className = ("btn-close");
	closeButton.setAttribute("type", "button");
	closeButton.setAttribute("data-bs-dismiss", "alert");
	closeButton.setAttribute("aria-label", "Close");

	const contactUsLink = `<a href="/contact-us" class="link-block-alert">contact us</a>`;
	let errorMessage = `Sorry, there's been an error. Please try again. If this continues, please ${contactUsLink}.`;

	if(error && error.message === '429') {
		errorMessage = `Sorry, you've made too many attempts. Please try again later. If you need help, please ${contactUsLink}.`
	}

	const errorInnerDiv = document.createElement("div");
	errorInnerDiv.className = "container";
	errorInnerDiv.innerHTML = errorMessage;
	errorInnerDiv.prepend(closeButton);

	errorDiv.appendChild(errorInnerDiv);
	document.body.prepend(errorDiv);

	// Uncollapsing looks a bit nicer than just appearing
	bsCollapse($(errorDiv)).show();

	// When it collapses (when hiding previously shown errors), remove from the DOM
	$(errorDiv).on("hidden.bs.collapse", (e) => {
		e.currentTarget.remove();
	});
}